import React, { Component } from 'react'
import './App.css'
import Home from './home/Home'

class App extends Component {
  render() {
    return (
      <div className="app">
        <Home />
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js